import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApplicationsContract } from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { terraApiWrapper } from '../../utils/terraApiWrapper';
import { ADAPTIVE_SCANNING_STATE_QUERY_KEY } from './useAdaptiveScanningState';

export const useSetAdaptiveScanningEnabled = ({
  applicationId,
}: {
  applicationId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (enabled: boolean) =>
      terraApiWrapper<typeof ApplicationsContract.setAdaptiveScanningEnabled>({
        endpointFn: () =>
          applicationsClient.setAdaptiveScanningEnabled({
            params: { id: applicationId },
            body: { enabled },
          }),
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ADAPTIVE_SCANNING_STATE_QUERY_KEY, applicationId],
      });
    },
  });
};
